import React, { useState } from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { FiCalendar, FiChevronRight } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NotificationBadge } from '../../Menu/Notifications/Components'
import Typography from '../components/Typography'
import { getReservationsListNew } from '../../../../../reducers/reservationsList/selectors'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'
import { isLicenseValid } from '../../../../../reducers/userAccount/selectors/license'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'

function ReservationList() {
  const eventsCount = useSelector(getReservationsListNew).length
  const userId = useSelector(getUserId)
  const { t } = useTranslation()
  const licenseValid = useSelector(isLicenseValid)
  const [isModalOpened, setIsModalOpened] = useState(false)

  function onClick() {
    if (licenseValid) {
      Mixpanel.track('Reservation List Menu Item Used', {})
      Mixpanel.people.increment(userId, 'Reservations Menu Opened', 1)
      ;(window as any).routerHistory.push('/booking/reservations', {})
    } else {
      setIsModalOpened(true)
    }
  }

  return (
    <>
      <ListItem style={{ minHeight: '60px' }} button={true} onClick={onClick}>
        <ListItemIcon style={{ minWidth: '30px', width: '30px' }}>
          <>
            <FiCalendar size={20} style={{ minHeight: 20, minWidth: 20 }} />
            <div style={{ left: '-15px', position: 'relative', top: '-10px' }}>
              <NotificationBadge
                taskCount={eventsCount ? String(eventsCount) : '0'}
              />
            </div>
          </>
        </ListItemIcon>
        <ListItemText
          primary={<Typography>
            {t('menu_reservations')}
            {!licenseValid && <div style={{marginLeft: '8px', display: 'inline-block'}}><PopoveredIcon2/></div>}
          </Typography>}
        />
        <FiChevronRight />
      </ListItem>

      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default ReservationList
